export default __webpack_public_path__ + "media/images/features/local_delivery/map-marker-line-c6b65b21d02fea6fe870ec930cbd0552.png";